import { __makeTemplateObject, __read } from "tslib";
import React from 'react';
import styled from '@marvelapp/styled';
import { AspectRatio, Box, PinAll } from '@marvelapp/ui';
import { CopyToClipboard } from '@marvelapp/ui-internal';
import * as convert from '../../utils/convertColours';
import TransparentBorder from './TransparentBorder';
import { SwatchBg } from './icons';
var ClipboardBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    width: 100%;\n    height: 100%;\n    flex: 1;\n  }\n"], ["\n  > div {\n    width: 100%;\n    height: 100%;\n    flex: 1;\n  }\n"])));
export default function PanelSwatch(_a) {
    var color = _a.color, iconWidth = _a.iconWidth, iconHeight = _a.iconHeight;
    var convertedRgba = convert.rgbaArray2rgba(color);
    var convertedColor = convert.rgbaArray2hex(color);
    var isLight = lightOrDark(color) === 'light';
    return (React.createElement(AspectRatio, { ratio: 1 / 1 },
        React.createElement(PinAll, { borderRadius: 1, overflow: "hidden", pointerEvents: "none" },
            React.createElement(SwatchBg, { height: "100%", width: "100%" })),
        React.createElement(ClipboardBox, { bg: convertedRgba, borderRadius: 1, className: "panelColor", cursor: "pointer", height: "100%", hoverOpacity: 0.75, position: "relative", transition: "smooth.fast", width: "100%" },
            React.createElement(CopyToClipboard, { alignItems: "stretch", as: ClipboardBox, btnText: "", flex: 1, height: "100%", iconColor: isLight ? 'slate' : 'white', iconHeight: iconHeight, iconWidth: iconWidth, justifyContent: "stretch", text: "#".concat(convertedColor), transitionType: "icon", width: "100%" })),
        React.createElement(TransparentBorder, null)));
}
function lightOrDark(color) {
    var _a = __read(color.map(function (n) { return n * 255; }), 3), r = _a[0], g = _a[1], b = _a[2];
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 125) {
        return 'light';
    }
    return 'dark';
}
var templateObject_1;
